import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../data/blogPosts';
import './Blog.css';

const BlogCard = ({ post, readMoreHref }) => (
  <article className="common-blog-card">
    <div className="common-blog-image-wrap">
      <img src={post.imageUrl || post.image} alt={post.title} loading="lazy" className="common-blog-image" />
    </div>
    <div className="common-blog-body">
      <div className="common-blog-meta">
        <span>{post.date}</span>
        {post.category && <span>{post.category}</span>}
      </div>
      <h3 className="common-blog-card-title">{post.title}</h3>
      <p className="common-blog-excerpt">{post.excerpt}</p>
      <Link to={readMoreHref || `/blog/${post.id}`} className="common-blog-link">Read more</Link>
    </div>
  </article>
);

const Blog = ({ title, subtitle, posts: postsProp }) => {
  const list = postsProp && postsProp.length > 0 ? postsProp : blogPosts;
  const normalized = list.map((p) => ({
    ...p,
    imageUrl: p.imageUrl || p.image,
  }));

  return (
    <section className="common-blog" id="blogs">
      <div className="common-blog-container">
        <div className="common-blog-header">
          {title && <h2 className="common-blog-title">{title}</h2>}
          <Link to="/blog" className="common-blog-view-all-link">View all</Link>
        </div>
        {subtitle && <p className="common-blog-subtitle">{subtitle}</p>}

        <div className="common-blog-scroll-wrap">
          <div className="common-blog-track">
            {normalized.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.id}`}
                className="common-blog-scroll-card"
              >
                <div className="common-blog-scroll-card-img">
                  <img src={post.imageUrl} alt="" loading="lazy" />
                  <span className="common-blog-scroll-card-tag">{post.category}</span>
                </div>
                <div className="common-blog-scroll-card-content">
                  <time>{post.date}</time>
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <span className="common-blog-scroll-card-cta">Read more →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
export { BlogCard };
